import template   from './installation.html'
import controller from './installation.controller'
import './installation.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/installation/installation.component.js